export const isNodeId = (id?: number): id is number => !!id;

export type IsNodeId = typeof isNodeId;
